import { z } from "zod";

import { CurrencyCode } from "@smartrr/shared/shopifyGraphQL/api";
import { getShopifyGidPrefix } from "@smartrr/shared/utils/ensureShopifyGid";

export namespace QuickbuyAPI {
  export namespace Variant {
    export const schema = z.object({
      name: z.string(),
      shopifyId: z.string().startsWith(getShopifyGidPrefix("ProductVariant"), {
        message: "Shopify ID must be defined with prefix",
      }),
      image: z.string(),
      price: z.object({
        amount: z.string(),
        currency: z.nativeEnum(CurrencyCode),
      }),
    });
    export type Type = z.infer<typeof schema>;
  }
  export namespace Product {
    export const schema = z.object({
      name: z.string(),
      image: z.string(),
      shopifyId: z.string().startsWith(getShopifyGidPrefix("Product"), {
        message: "Shopify ID must be defined with prefix",
      }),
      variants: z.array(QuickbuyAPI.Variant.schema),
    });
    export type Type = z.infer<typeof schema>;
  }
  export namespace Search {
    export const schema = z.object({
      limit: z.coerce
        .number()
        .int()
        .min(5, { message: "Minimum 5 products per page." })
        .max(10, { message: "Maximum 10 products per page." }),
      offset: z.coerce.number().int().min(0, { message: "Minimum page number is 0." }),
      productName: z.string().optional(),
    });
    export type Type = z.infer<typeof schema>;
  }
}
